module.exports = __webpack_public_path__ + "static/media/LiberalBoard_0.f067a45c.png";